import { ActionReducerMap } from '@ngrx/store';

export const communicationsModuleKey = 'communications';

import * as fromCommunications from './communications/communications.reducer';
import * as fromWorkflow from './workflow/workflow.reducer';

export interface CommunicationsModuleState {
  communications: fromCommunications.State;
  workflow: fromWorkflow.State;
}

export const reducers: ActionReducerMap<CommunicationsModuleState> = {
  communications: fromCommunications.reducer,
  workflow: fromWorkflow.reducer,
};

